import React from 'react';
import Breadcrumb from '../../components/breadcrumb/breadcrumb';
import Sidebar from '../../components/sidebar/sidebar';
import DetailedProduct from '../../components/product/detailedProduct';
import DetailsHeading from '../../components/detailsHeading/detailsHeading';
import CardIngredients from '../../components/card/cardIngredients';
import CardNutritional from '../../components/card/cardNutritional';
//import SuggestedProductsHeading from '../../components/product/suggestedProductsHeading';
//import DiscoverProduct from '../../components/product/discoverProduct';
import HorizontalMenu from '../../components/sidebar/horizontalMenu';
import RotatingDiv from '../../components/rotatingDiv/rotatingDiv';

//import product images
import eucalipto from '../../images/products/eucalipto.png';
//import fig from '../../images/products/fig.png';

function Anis() {
    /*const suggestions = [
        {
            name: 'Doce de Figo Pingo de Mel',
            photo: fig,
            link: '/originalberry',
            className: 'floryptus-link',
        },
    ];*/

    return (
        <>
            <div className="horizontal-menu">
                <HorizontalMenu />
            </div>
            <div className="breadcrumb-container">
                <Breadcrumb
                    home="Home"
                    section="Produtos"
                    category="Doces de Physalis"
                    name="Eucalipto"
                ></Breadcrumb>
            </div>
            <div className="product-details-grid">
                <div className="sidebar-menu padding-top30 padding-left50">
                    <Sidebar />
                </div>
                <DetailedProduct
                    photo={eucalipto}
                    name="Eucalipto"
                    color="dark-green-text"
                    category="Doces de Physalis"
                    description="De um dueto improvável nasce um doce de propriedades únicas. Uma experiência para os sentidos que nos faz
                    mergulhar nos aromas da floresta."
                    weight="Frasco de 245g"
                    link="/contacts"
                    buttonColor="btn--eucalipto"
                    buttonText="Online"
                ></DetailedProduct>
                <div className="details">
                    <div className="details-title">
                        <DetailsHeading
                            text="Detalhes"
                            type="eucalipto"
                        ></DetailsHeading>
                    </div>
                    <div className="cards">
                        <div className="card-ingridients-container">
                            <CardIngredients
                                percentage="60%"
                                sugar="yes"
                                salt="yes"
                                specialIngredient="Eucalipto (Eucalytus globulus)"
                            ></CardIngredients>
                            <RotatingDiv>
                                <div className="svg-eucalipto stripes-pattern-container"></div>
                            </RotatingDiv>
                        </div>
                        <div className="card-nutritional-container mb-100">
                            <CardNutritional
                                energy="1187 kj / 280 kcal"
                                lipids="0.45 g"
                                saturados="0.02 g"
                                hydrates="65.25 g"
                                sugars="54.50 g"
                                fiber="2.90 g"
                                proteins="1.25 g"
                                salt="0.50 g"
                            ></CardNutritional>
                            <RotatingDiv>
                                <div className="svg-eucalipto stripes-pattern-container2"></div>
                            </RotatingDiv>
                        </div>
                    </div>
                </div>
                {/*
                <div className="suggestions-heading">
                    <SuggestedProductsHeading
                        question="Improvável é também esta sugestão"
                        answer="Descubra-a aqui:"
                        color="dark-green-text"
                    ></SuggestedProductsHeading>
                </div>
                <div className="discover-section-grid">
                    {suggestions.map((discoverProduct, idx) => (
                        <DiscoverProduct
                            key={idx}
                            discoverProduct={discoverProduct}
                        />
                    ))}
                    </div>*/}
            </div>
        </>
    );
}

export default Anis;
